











import {Component, Vue} from 'vue-property-decorator';
import {OmniUsuarioEnum} from '@/helpers/omni-usuario.enum';

@Component({})
export default class App extends Vue {
  public noBar: boolean = !!localStorage.getItem(OmniUsuarioEnum.NO_BAR);
  
  mounted() {
    this.loadScriptGlassBox();
  }

  private loadScriptGlassBox() {
    const script = document.createElement('script');
    script.onload = () => {
    };
    script.src = process.env.BASE_URL + process.env.VUE_APP_REPORT_URI_GLASSBOX;
    script.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(script);
  }
}
